<div class="container" style="padding: 5px">
  <form #passwordChangeForm="ngForm" (ngSubmit)="changePassword(passwordChangeForm)" (keydown.enter)="$event.preventDefault()" [formGroup]="passwordForm">
    <div class="form-group">
      <label for="oldPassword">Parolă actuală</label>
      <div>
        <input type="password" name="OldPassword" formControlName="OldPassword" class="form-control" id="oldPassword">
      </div>
    </div>
    <div class="form-group">
      <label for="newPassword">Parolă nouă</label>
      <div>
        <input type="password" name="NewPassword" formControlName="NewPassword" class="form-control" id="newPassword">
      </div>

    </div>
    <div class="form-group">
      <label for="newPasswordRepeat">Repetare parolă nouă</label>
      <div>
        <input type="password" name="NewPasswordRepeat" formControlName="NewPasswordRepeat" class="form-control" id="newPasswordRepeat">
      </div>

    </div>
    <div class="row">
      <button class="btn btn-warning" style="margin: 1%" (click)="cancelChangePassword()"><i class="far fa-times-circle"></i> Anulare</button>
      <button
        type="submit" class="btn btn-success" style="margin: 1%"><i class="fas fa-check"></i> Schimbare parolă</button>
    </div>

  </form>
</div>
